import { useMutation } from 'react-query';
import request from '../../../helpers/request';
import { toDateStr } from '../../../helpers/utcDate';
import useDocsBind from './useDocsBind';
import { useDispatch, useSelector } from 'react-redux';
import { documentDrawerSelector } from '../store/selectors/new-document.selector';
import { actionConst } from '../constants/new-document.constants';
import { documentsConstants } from '../constants/documents.constants';
import useAddDocsAttachFile from './useAddDocsAttachFile';
import useAddNoteDocs from './useAddNoteDocs';

const createDocs = async ({ values: value }) => {
  const orgs =
    (value.typeId < 3 || value.typeId === 4) &&
    value.subTypeId !== 7 &&
    value.contractorType !== 'fio_data'
      ? []
      : undefined;
  if (orgs) {
    value.orgsKeys.forEach((e) => {
      if (e || e === 0) {
        const o = {
          Id: null,
          OrgId: value.orgId && value.orgId[e] && parseInt(value.orgId[e]),
        };
        orgs.push(o);
      }
    });
  }

  const data = {
    Id: 0,
    TypeId: parseInt(value.typeId),
    DocNumber: value.DocNumber,
    DocDate: value.docDate && toDateStr(value.docDate),
    AppointedWorkers:
      value.executerIds &&
      value.executerIds
        .map((appointedWorker) => parseInt(appointedWorker))
        .filter(Boolean),

    AddressIds:
      value.addressIds &&
      value.addressIds.filter(Boolean).map((addressId) => parseInt(addressId)),
    ClientName: value.custNames && value.custNames?.filter(Boolean),
    ResponsibleWorkerId: parseInt(value.ResponsibleWorkerId),
    ServiceCompanyId: parseInt(value.serviceCompanyId),
    DocumentVisibility: parseInt(value.documentVisibility),
    ...(!!value.doneDate ? { DoneDate: toDateStr(value.doneDate) } : {}),
    ...(!!value.ordTypeId
      ? { OrganizationalTypeId: parseInt(value.ordTypeId) }
      : {}),
    ...(!!(value.orgId && value.orgId[0])
      ? { OrgId: parseInt(value.orgId[0]) }
      : {}),
    ...(!!(orgs?.length > 0) ? { Orgs: orgs } : {}),
    ...(!!value.DeadlineDate
      ? { DeadlineDate: toDateStr(value.DeadlineDate) }
      : {}),
    ...(!!value.topicId ? { topicId: parseInt(value.topicId) } : {}),
    ...(!!value.subTypeId ? { subTypeId: parseInt(value.subTypeId) } : {}),
    ...(!!value.sourceNumber ? { sourceNumber: value.sourceNumber } : {}),
    ...(!!value.sourceDate ? { sourceDate: toDateStr(value.sourceDate) } : {}),
    ...(!!value.topic ? { topic: value.topic } : {}),
  };

  return await request.post(
    '/Docs',
    data,
    'При создании документа произошла ошибка',
    'Error'
  );
};

const useCreateDocs = () => {
  const { onBindDocs, isLoading: isBindLoading } = useDocsBind();
  const { onMutation, isLoading } = useAddDocsAttachFile();
  const { isLoadingDocsNote, addDocsNote } = useAddNoteDocs();

  const { savedDraft } = useSelector(documentDrawerSelector);

  const dispatch = useDispatch();

  const mutation = useMutation(createDocs, {
    onSuccess: async (data, { documentId, values }) => {
      if (data === 'Error') {
        dispatch({
          type: documentsConstants.POST_ERROR,
          payload: 'При создании документа произошла ошибка',
        });
        return;
      }

      const attachments = values.addonfiles;

      if (attachments && attachments.length > 0) {
        await onMutation({ docId: data, files: attachments });
      }

      const note = values.note;

      if (!!note?.trim()) {
        await addDocsNote({ docId: data, note: note?.trim() });
      }

      if (!Boolean(savedDraft)) {
        dispatch({
          type: actionConst.POST_DOCUMENT,
          payload: data,
        });
      }

      if (!!savedDraft) {
        await onBindDocs({
          documentId,
          bindEntityTypeId: 2,
          bindEntityId: Number(data),
        });
      }
    },
  });

  return {
    isLoading:
      mutation.isLoading || isBindLoading || isLoading || isLoadingDocsNote,
    createDocs: mutation.mutateAsync,
  };
};

export default useCreateDocs;
